<template>
  <el-dialog
    :visible="visible"
    :title="title"
    width="1000px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-form
      ref="form"
      label-width="100px"
      label-position="left"
      :model="form"
      :show-message="false"
    >
      <el-row :gutter="8">
        <el-col :span="8">
          <el-form-item
            label="包装号"
            required
            prop="packageNo"
          >
            <el-input v-model="form.packageNo" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="8">
          <el-form-item
            label="包装类型"
            required
            prop="packageType"
          >
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packageType"
              tag-name="englishName"
              style="width:100%;"
              @parentCallBack="p=>form.packageType=p.value"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="8"
        style="display:flex"
      >
        <el-col :span="15">
          <el-form-item
            required
            label="单箱体积"
            class="volume-col"
          >
            <el-col
              :span="4"
              style="margin-left:-4px"
            >
              <el-form-item
                required
                prop="estimatedLength"
              >
                <el-input
                  v-model="form.estimatedLength"
                  placeholder="长(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >x</el-col>
            <el-col :span="4">
              <el-form-item
                required
                prop="estimatedWidth"
              >
                <el-input
                  v-model="form.estimatedWidth"
                  placeholder="宽(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >x</el-col>
            <el-col :span="4">
              <el-form-item
                required
                prop="estimatedHeight"
              >
                <el-input
                  v-model="form.estimatedHeight"
                  placeholder="高(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >=</el-col>
            <el-col :span="5">{{ form.estimatedUnitCubage }}</el-col>
            <el-col :span="3">CBM</el-col>
          </el-form-item>
          <el-row :gutter="8">
            <el-col :span="20">
              <el-form-item
                label="单箱重量"
                required
                prop="estimatedUnitGrossWeight"
              >
                <el-input v-model="form.estimatedUnitGrossWeight" />
              </el-form-item>
            </el-col>
            <el-col :span="3">KGS</el-col>
          </el-row>
        </el-col>
        <el-col
          :span="3"
          style="flex-grow:1;display:flex;align-items:center;margin-top:0"
        >
          <el-row :gutter="8">
            <el-col :span="5">x</el-col>
            <el-col :span="14">
              <el-form-item
                label-width="0"
                required
                prop="estimatedQuantity"
              >
                <el-input
                  v-model="form.estimatedQuantity"
                  placeholder="箱数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">=</el-col>
          </el-row>
        </el-col>
        <el-col :span="6">
          <el-row>
            <el-col :span="6">总体积</el-col>
            <el-col
              :span="12"
              style="text-align:right"
            >{{ form.estimatedCubage }}</el-col>
            <el-col
              :span="6"
              style="text-align:right"
            >CBM</el-col>
          </el-row>
          <el-row>
            <el-col :span="6">总重量</el-col>
            <el-col
              :span="12"
              style="text-align:right"
            >{{ form.estimatedGrossWeight }}</el-col>
            <el-col
              :span="6"
              style="text-align:right"
            >KGS</el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="8">
          <el-form-item
            label="生产商"
            prop="producerId"
          >
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :default-value="form.producerId||''"
              tag-name="chineseName"
              style="width:100%;"
              :method-params="{factorySign:true}"
              @parentCallBack="p=>form.producerId=p.value"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="预计货好时间"
            prop="estimatedIncomeDate"
          >
            <el-date-picker
              v-model="form.estimatedIncomeDate"
              type="date"
              clearable
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="实际进仓时间"
            prop="incomeDate"
          >
            <el-date-picker
              v-model="form.warehouseInDate"
              disabled
              type="date"
              clearable
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="注意事项"
        prop="matters"
      >
        <el-input v-model="form.matters" />
      </el-form-item>
      <el-row style="margin-bottom:15px">
        <el-col>
          <el-button
            type="primary"
            @click="handleAddGoods"
          >添加商品</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="form.poPackageItemList"
        size="medium"
        class="goodsTable"
      >
        <el-table-column>
          <template slot="header"><span style="color:red">*</span>订单号</template>
          <template slot-scope="scope">
            <el-form-item
              :prop="'poPackageItemList.'+scope.$index+'.poInfoUuid'"
              label-width="0"
              required
            >
              <cargo-advance-select
                :remote="true"
                :cache="false"
                filterable
                :url="URL.order.searchPoInfoByPoNo"
                :wait="0"
                :default-value="scope.row.poInfoUuid"
                :remote-default-obj="{poNo:scope.row.poNo,uuid:scope.row.poInfoUuid}"
                :method-params="{customerId}"
                tag-name="poNo"
                tag-value="uuid"
                style="width:100%;"
                @parentCallBack="p=>form.poPackageItemList[scope.$index].poInfoUuid=p.value"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header"><span style="color:red">*</span>SKU编码</template>
          <template slot-scope="scope">
            <el-form-item
              :prop="'poPackageItemList.'+scope.$index+'.poItemUuid'"
              label-width="0"
              required
            >
              <cargo-advance-select
                :disabled="!scope.row.poInfoUuid"
                :remote="true"
                :cache="false"
                filterable
                :url="URL.order.searchPoItem"
                :wait="0"
                :remote-keyword-length="1"
                :default-value="scope.row.poItemUuid"
                :method-params="{poInfoUuid:scope.row.poInfoUuid}"
                :remote-default-obj="{itemNo:scope.row.itemNo,uuid:scope.row.poItemUuid}"
                :fields="['itemNo','chineseCommodity','englishCommodity']"
                :headers="['SKU编码','中文名称','英文名称']"
                tag-name="itemNo"
                tag-value="uuid"
                style="width:100%;"
                @parentCallBack="p=>{poItemSelected(p,scope.$index)}"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="中文品名"
          prop="chineseCommodity"
        />
        <el-table-column
          label="英文品名"
          prop="englishCommodity"
        />
        <el-table-column>
          <template slot="header"><span style="color:red">*</span>SKU数量</template>
          <template slot-scope="scope">
            <el-form-item
              :prop="'poPackageItemList.'+scope.$index+'.quantity'"
              label-width="0"
              required
            >
              <el-input v-model="scope.row.quantity" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">纸箱数</template>
          <template slot-scope="scope">
            <el-form-item
              :prop="'poPackageItemList.'+scope.$index+'.cartonQuantity'"
              label-width="0"
            >
              <el-input v-model="scope.row.cartonQuantity" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDelGoods(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div
      slot="footer"
      style="text-align:center"
    >
      <el-form>
        <span>
          <el-button
            type="primary"
            @click="onSave"
          >保存</el-button>
          <el-button @click="onClose">取消</el-button>
        </span>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { queryPoPackage } from '@/api/OMS/order'
import { getLoading } from '@/utils/utilBaseElement'
import { formatRoundNumber } from '@/utils/NumberUtils'
import { isPositiveInteger, isPositiveNumber } from '@/utils/validate'
export default {
  name: 'PackageInfoForm',
  components: { cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => true
    },
    poNo: { type: String, default: () => '' },
    orderUuid: { type: String, default: () => '' },
    customerId: { type: Number, default: () => null },
    uuid: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      URL,
      form: {
        packageNo: '',
        packageType: '',
        cartonQuantity: '',
        estimatedWidth: '',
        estimatedHeight: '',
        estimatedLength: '',
        estimatedUnitCubage: 0,
        estimatedUnitGrossWeight: '',
        estimatedQuantity: '',
        estimatedCubage: 0,
        estimatedGrossWeight: 0,
        producerId: '',
        estimatedIncomeDate: '',
        incomeDate: '',
        matters: '',
        uuid: null,
        poPackageItemList: [],
        poPackageItemDelList: [],
        version: null
      },
      selectTypeNames: TYPE_NAMES
    }
  },
  computed: {
    title() {
      return this.uuid ? '编辑包装' : '新增包装'
    }
  },
  watch: {
    uuid(val) {
      if (val) {
        queryPoPackage({ poPackageUuid: val })
          .then((res) => {
            const { data } = res
            Object.keys(this.form).forEach((key) => {
              if (data.poPackage[key]) {
                this.form[key] = data.poPackage[key]
              }
            })
            this.form.poPackageItemList = data.poPackageItemList
          })
          .catch(() => {
            this.loading.close()
          })
      }
    },
    'form.estimatedLength': {
      handler(val) {
        const { estimatedWidth, estimatedHeight } = this.form
        if (val && estimatedWidth && estimatedHeight) {
          this.form.estimatedUnitCubage = formatRoundNumber(
            (val * estimatedWidth * estimatedHeight) / 1000000,
            3
          )
        } else {
          this.form.estimatedUnitCubage = 0
        }
      },
      deep: true
    },
    'form.estimatedWidth': {
      handler(val) {
        const { estimatedLength, estimatedHeight } = this.form
        if (val && estimatedLength && estimatedHeight) {
          this.form.estimatedUnitCubage = formatRoundNumber(
            (val * estimatedLength * estimatedHeight) / 1000000,
            3
          )
        } else {
          this.form.estimatedUnitCubage = 0
        }
      },
      deep: true
    },
    'form.estimatedHeight': {
      handler(val) {
        const { estimatedWidth, estimatedLength } = this.form
        if (val && estimatedWidth && estimatedLength) {
          this.form.estimatedUnitCubage = formatRoundNumber(
            (val * estimatedWidth * estimatedLength) / 1000000,
            3
          )
        } else {
          this.form.estimatedUnitCubage = 0
        }
      },
      deep: true
    },
    'form.estimatedUnitGrossWeight': {
      handler(val) {
        const { estimatedQuantity } = this.form
        if (val && estimatedQuantity) {
          this.form.estimatedGrossWeight = formatRoundNumber(
            estimatedQuantity * val,
            2
          )
        } else {
          this.form.estimatedGrossWeight = 0
        }
      },
      deep: true
    },
    'form.estimatedQuantity': {
      handler(val) {
        const { estimatedUnitGrossWeight, estimatedUnitCubage } = this.form
        if (val && estimatedUnitGrossWeight) {
          this.form.estimatedGrossWeight = formatRoundNumber(
            val * estimatedUnitGrossWeight,
            2
          )
        } else {
          this.form.estimatedGrossWeight = 0
        }
        if (val && estimatedUnitCubage) {
          this.form.estimatedCubage = formatRoundNumber(
            val * estimatedUnitCubage,
            3
          )
        } else {
          this.form.estimatedCubage = 0
        }
      },
      deep: true
    },
    'form.estimatedUnitCubage': {
      handler(val) {
        const { estimatedQuantity } = this.form
        if (val && estimatedQuantity) {
          this.form.estimatedCubage = formatRoundNumber(
            estimatedQuantity * val,
            3
          )
        } else {
          this.form.estimatedCubage = 0
        }
      },
      deep: true
    }
  },
  methods: {
    onSave() {
      const { form } = this
      const poPackage = {
        ...form
      }
      if (!poPackage.packageNo.trim()) {
        this.$message.warning('包装号不能为空')
        return
      }
      if (!poPackage.packageType) {
        this.$message.warning('包装类型不能为空')
        return
      }
      if (!isPositiveNumber(poPackage.estimatedLength)) {
        this.$message.warning('长应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.estimatedWidth)) {
        this.$message.warning('宽应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.estimatedHeight)) {
        this.$message.warning('高应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.estimatedUnitGrossWeight)) {
        this.$message.warning('单箱重量应为大于0的数字')
        return
      }
      if (!isPositiveInteger(poPackage.estimatedQuantity)) {
        this.$message.warning('箱数应为大于0的整数')
        return
      }
      const { poPackageItemList } = this.form
      if (poPackageItemList.length === 0) {
        this.$message.warning('请添加商品')
        return
      }
      for (let i = 0; i < this.form.poPackageItemList.length; i++) {
        if (!poPackageItemList[i].poInfoUuid.trim()) {
          this.$message.warning('订单号不能为空')
          return
        }
        if (!poPackageItemList[i].poItemUuid.trim()) {
          this.$message.warning('SKU编码不能为空')
          return
        }
        if (!isPositiveInteger(poPackageItemList[i].quantity)) {
          this.$message.warning('SKU数量必须为大于0的整数')
          return
        }
        if (
          poPackageItemList[i].cartonQuantity &&
          !isPositiveInteger(poPackageItemList[i].cartonQuantity)
        ) {
          this.$message.warning('纸箱数必须为大于0的整数')
          return
        }
      }
      this.loading = getLoading()
      if (this.uuid) {
        poPackage.uuid = this.uuid
      }
      delete poPackage.poPackageItemList
      delete poPackage.poPackageItemDelList
      const data = {
        poPackage,
        poPackageItemList: form.poPackageItemList,
        poPackageItemDelList: form.poPackageItemDelList
      }
      this.$emit('onSave', data)
    },
    onClose() {
      this.$emit('onClose')
      this.form.uuid = null
      this.form.poPackageItemList = []
      this.form.poPackageItemDelList = []
      this.form.version = null
    },
    handleAddGoods() {
      this.form.poPackageItemList.push({
        uuid: '',
        poNo: this.poNo,
        poInfoUuid: this.orderUuid,
        poItemUuid: '',
        itemNo: '',
        quantity: '',
        chineseCommodity: '',
        englishCommodity: '',
        poPackageUuid: '',
        cartonQuantity: ''
      })
    },
    handleDelGoods(index) {
      console.log(index, this.form.poPackageItemList[index])
      if (this.form.poPackageItemList[index].uuid) {
        this.form.poPackageItemDelList.push(
          this.form.poPackageItemList[index].uuid
        )
      }
      this.form.poPackageItemList.splice(index, 1)
    },
    poItemSelected(p, index) {
      this.form.poPackageItemList[index].poItemUuid = p.value
      this.form.poPackageItemList[index].chineseCommodity = p.chineseCommodity
      this.form.poPackageItemList[index].englishCommodity = p.englishCommodity
      this.form.poPackageItemList[index].itemNo = p.itemNo
    }
  }
}
</script>
<style lang="scss">
#app .app-main-inner-row .el-form .volume-col {
  .el-col {
    margin-top: 0;
  }
}

.goodsTable {
  .el-form-item {
    margin: 8px;
  }
}
</style>
